import { Base } from "@studiometa/js-toolkit";
class Switcher extends Base {
  /**
   * Config.
   */
  static config = {
    name: "Switcher",
    refs: ["inputs[]"],
    emits: ["switch"]
  };
  get value() {
    return this.$refs.inputs.find((input) => input.checked)?.value;
  }
  onInputsInput() {
    this.switch(this.value);
    this.$emit("switch", this.value);
  }
  switch(_value) {
    throw new Error("The `switch` method must be implemented.");
  }
}
export {
  Switcher as default
};
//# sourceMappingURL=Switcher.js.map
